angular.module('bribac.actions.currentAgentId', [])

  .constant('currentAgentIdActions', {
    SET: function(id) {
      return {
        type: 'CURRENT_AGENT_ID.SET',
        payload: {id: id}
      }
    }
  })
